module.exports = __webpack_public_path__ + "50476bceca9f4fb22a07199d70622f3f.svg";